
import { Component, Vue } from "vue-property-decorator";

@Component({})
/**
 * 1. 使用 input 框唤起相机
 *    -> 上传拍照的照片，调用接口 /v1/component/exec 核验
 */
export default class ComInputVerify extends Vue {
  imgUrl: any = "";
  file: any = null;
  imgData: any = null;

  openCamera() {
    this.file = null;
    this.imgUrl = "";
    this.imgData = null;
    (this.$refs.cameraInput as HTMLElement)?.click();
  }

  // input 框唤起原生相机拍照 & 上传 & 核验
  getPhotoAndVerify(ev: any) {
    // 获取拍照照片
    console.log("inputCameraFaceVerify", ev);
    const file = ev.target.files[0];
    this.file = file;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.imgData = reader.result;
    };
    // 上传图片 & 开始核验
    this.$emit("verify", this.file);
  }
}
